export const SAVE_BASE = 'INTEGRATION_CONFIG_SAVE';
export const SAVE_START = `${SAVE_BASE}_START`;
export const SAVE_SUCCESS = `${SAVE_BASE}_SUCCESS`;
export const SAVE_FAIL = `${SAVE_BASE}_FAIL`;

export const POST_COMM_PLAN = 'POST_COMMUNICATION_PLAN';
export const POST_COMM_PLAN_START = `${POST_COMM_PLAN}_START`;
export const POST_COMM_PLAN_SUCCESS = `${POST_COMM_PLAN}_SUCCESS`;
export const POST_COMM_PLAN_FAIL = `${POST_COMM_PLAN}_FAIL`;

export function save(payload) {
  return {
    type: SAVE_BASE,
    meta: {
      xmApi: true,
      uri: '/webapi/xm/1/built-in-plans',
      method: 'post',
      params: payload,
    },
  };
}

export function savePlan(id, planType) {
  return {
    type: POST_COMM_PLAN,
    meta: {
      xmApi: true,
      uri: '/webapi/xm/1/plans',
      method: 'post',
      params: {
        id,
        planType,
      },
    },
  };
}
